import { gsap, ScrollTrigger } from '@hh/gsap.js'
gsap.registerPlugin(ScrollTrigger)

class HHImageGrid extends HTMLElement {
  constructor() {
    super()

    this.isScrolling = false
    this.animationTimeout = null

    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
  }

  handleResize = () => {
    clearTimeout(this.animationTimeout)

    ScrollTrigger.getAll().forEach((trigger) => {
      trigger.kill()
    })

    this.animationTimeout = setTimeout(() => {
      this.animationFunction()
    }, 300) // Delay the animation initialization to reduce performance impact
  }

  handleScroll = () => {
    this.isScrolling = true

    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout)
    }

    this.animationTimeout = setTimeout(() => {
      this.isScrolling = false
    }, 200) // Delay resetting the scrolling flag to optimize performance
  }

  connectedCallback() {
    this.element = this.querySelector('.js-image-grid-main')
    this.sideColumns = this.querySelectorAll('.js-image-grid-side')

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.height = this.querySelector('.js-image-grid-height').clientHeight
        this.cardHeight = this.querySelector('.js-image-grid-card').clientHeight
        this.animationFunction()
      })
    })
  }

  animationFunction = () => {
    const observer1 = new IntersectionObserver(this.handleIntersectionMain, {
      root: null,
      threshold: 0,
    })

    const observer2 = new IntersectionObserver(this.handleIntersectionSide, {
      root: null,
      threshold: 0,
    })

    observer1.observe(this.element)
    this.sideColumns.forEach((sideColumn) => {
      observer2.observe(sideColumn)
    })
  }

  handleIntersectionMain = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.isScrolling) {
        gsap.to(entry.target, {
          marginTop: this.cardHeight * -1,
          ease: 'none',
          scrollTrigger: {
            trigger: entry.target,
            start: 'top top',
            end: `+=${this.height}`,
            scrub: true,
          },
        })
      }
    })
  }

  handleIntersectionSide = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.isScrolling) {
        gsap.to(entry.target, {
          y: Math.round(window.innerHeight / 5),
          ease: 'none',
          scrollTrigger: {
            trigger: entry.target,
            start: 'top top',
            end: `bottom bottom`,
            scrub: true,
          },
        })
      }
    })
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

customElements.define('hh-image-grid', HHImageGrid)
